const usecase = {
  namespaced: true,
  state: {
    tabs: 'data',
    badge: 0,
  },
  mutations: {
    SET_TABS: (state: any, tab: string) => {
      state.tabs = tab;
    },
    SET_BADGE: (state: any, number: string) => {
      state.badge = number;
    },
  },
  actions: {},
};

export default usecase;
